import logo from '../assets/logo.png';
import banner from '../assets/banner.jpg'; // Tu banner

const Header = () => (
  <header className="relative w-full h-[300px] md:h-[400px] bg-cover bg-center bg-no-repeat shadow-lg" style={{ backgroundImage: `url(${banner})` }}>
    <div className="absolute inset-0 bg-gradient-to-br from-primary-900/90 via-primary-800/80 to-transparent"></div>

    <div className="relative z-10 container mx-auto px-4 h-full flex flex-col justify-center items-start">
      <a href="https://www.unlz.edu.ar" target="_blank" rel="noopener noreferrer" className="mb-6 hover:opacity-80 transition-opacity">
        <img src={logo} alt="Logo UNLZ" className="h-16 md:h-20 brightness-0 invert drop-shadow-md" />
      </a>

      <div className="text-white max-w-2xl">
        <h1 className="text-4xl md:text-5xl font-extrabold mb-2 tracking-tight drop-shadow-lg">
          Buscá tu carrera
        </h1>
        <p className="text-xl md:text-2xl font-light border-l-4 border-accent-500 pl-4">
          en la Primera del Conurbano
        </p>
      </div>
    </div>
  </header>
);
export default Header;
